import { useCallback } from 'react';
import { useDarkly } from 'integrations/launchDarkly/legacy/useDarkly';
import { useSettingsService } from 'common/settingsService';
import { useFeatureFlags } from 'common/featureFlag/useFeatureFlags';
import { LaunchDarklyFeatureFlagKeys } from 'integrations/launchDarkly/legacy/LaunchDarklyFeatureFlags.types';
import { useStaticPermissions } from '../../../common/auth/Authorize';
import { EngagementNavItem } from './EngagementsHome.constants';
import { navItems } from './EngagementsHome.navItems';
import { useEngagementsIntl } from './translations/useEngagementsIntl';

export function useEngagementRoutes(): EngagementNavItem[] {
  const flags = useDarkly();
  const settingsService = useSettingsService();
  const intl = useEngagementsIntl();
  const isLDFlagOnOrUndefined = useCallback(
    (flag?: LaunchDarklyFeatureFlagKeys) => typeof flag === 'undefined' || !!flags[flag],
    [flags]
  );
  const verifyPermission = useStaticPermissions();
  const { isEnabled } = useFeatureFlags(true);

  return navItems
    .map((item) => ({ ...item, label: intl[`engagements.${item.path}` as keyof typeof intl] as string }))
    .filter((item) => {
      const deniedPermission = item.permissions.find(
        (permission) => !verifyPermission({ permissionName: permission.name }, true)[permission.action]
      );

      if (!item.flag) {
        return !deniedPermission;
      }

      return (
        !deniedPermission &&
        (isLDFlag(item.flag)
          ? isLDFlagOnOrUndefined(item.flag.value)
          : isTenantYmlFlag(item.flag)
            ? isEnabled(item.flag.value)
            : settingsService.isEnabled(item.flag.group, item.flag.value))
      );
    });
}

function isLDFlag(item?: { source: string }): item is { source: 'LaunchDarkly' } {
  return item?.source === 'LaunchDarkly';
}

function isTenantYmlFlag(item?: { source: string }): item is { source: 'TenantYml' } {
  return item?.source === 'TenantYml';
}
